import { useEffect, useState } from 'react';

/**
 * How long a search box waits after the last keystroke before it searches.
 * Long enough that "Jane Smith" is one request, not ten; short enough that it
 * still feels like search-as-you-type.
 */
export const SEARCH_DEBOUNCE_MS = 350;

/**
 * `value`, but only once it has stopped changing for `delay` ms.
 *
 * The first render returns `value` straight away, so a box that opens with a
 * search already in it does not wait. The pending timer is cleared on unmount,
 * so a search typed just before navigating away never fires afterwards.
 */
export default function useDebouncedValue(value, delay = SEARCH_DEBOUNCE_MS) {
    const [debounced, setDebounced] = useState(value);

    useEffect(() => {
        const timer = setTimeout(() => setDebounced(value), delay);

        return () => clearTimeout(timer);
    }, [value, delay]);

    return debounced;
}
